import { Card, iconSizes, Stack, Text, Title } from '@common/ui'
import { IconExclamationCircle } from '@common/ui/icons'
import Center from '../../components/layout/Center'

const EntityTypeNotAccessibleError = () => (
  <Center style={{ minHeight: '100vh', backgroundColor: 'var(--trellis-color-surface-variant)' }}>
    <Card withBorder shadow="md" maw={400} ta="center" p="md">
      <Stack gap="xs" align="center">
        <IconExclamationCircle size={iconSizes.xl} stroke={1.5} color="var(--trellis-color-negative)" />
        <Title order={4}>Entity Type Not Accessible</Title>
        <Text mt="xs">The entity type you are trying to view is either not accessible to you or does not exist.</Text>
      </Stack>
    </Card>
  </Center>
)

export default EntityTypeNotAccessibleError
